__turbopack_context__.v({
  "body": "TestResultModal-module__QoX8_a__body",
  "failed": "TestResultModal-module__QoX8_a__failed",
  "passed": "TestResultModal-module__QoX8_a__passed",
  "status": "TestResultModal-module__QoX8_a__status",
  "text": "TestResultModal-module__QoX8_a__text",
});
